<template>
  <div class="add_article">
    <div class="pingpai">
      <van-cell
        title="品牌"
        center
        is-link
        :value="pingpai || '请选择品牌'"
        @click="brandshow = true"
      />
    </div>
    <div class="hangye">
      <van-cell
        title="行业"
        center
        is-link
        :value="hangye || '请选择行业'"
        @click="cateshow = true"
      />
    </div>
    <div class="add_box">
      <van-field
        v-model="value"
        type="textarea"
        rows="3"
        autosize
        placeholder="把你想要的文章、视频链接粘贴在这里..."
      />
    </div>
    <div class="add_btn" @click="issue">确认添加</div>
    <div class="add_method">
      <h1>快速添加方法</h1>
      <h3>1、复制你想要的文章/视频链接</h3>
      <img src="../../../assets/images/bg_upload_by_link_1.afb08070.png" />
      <img src="../../../assets/images/bg_upload_by_link_2.70003df0.png" />
      <h3>2、把链接粘贴在上面的输入框里添加</h3>
      <p>
        (或者打卡公众号，发送复制好的链接，系统会自动转换为你的文章/视频)
      </p>
      <img src="../../../assets/images/bg_upload_by_link_3.6dc34a3a.png" />
    </div>
    <div class="bottom_btn">
      <div @click="upvideo">
        <img src="../../../assets/images/add_01.png" />
        <p>上传手机视频</p>
        <input
          style="float: left; display: none"
          type="file"
          id="uploadFile"
          accept="video/*"
          @change="readLocalFile()"
        />
      </div>
      <div @click="oneself">
        <img src="../../../assets/images/add_03.png" />
        <p>自己写文章</p>
      </div>
      <router-link to="/my/issue" tag="div">
        <img src="../../../assets/images/add_02.png" />
        <p>我的文章</p>
      </router-link>
    </div>
    <van-popup position="bottom" round v-model="brandshow">
      <van-picker
        title="品牌"
        show-toolbar
        :columns="brand"
        @confirm="onBrand"
        @cancel="brandshow = false"
      >
        <template #confirm
          ><span class="picker_confirm">确定</span>
        </template>
        <template #option="item">
          <span class="span_color">{{ item.title }}</span>
        </template>
      </van-picker>
    </van-popup>
    <van-popup position="bottom" round v-model="cateshow">
      <van-picker
        title="行业"
        show-toolbar
        :columns="cate"
        @confirm="onCate"
        @cancel="cateshow = false"
      >
        <template #confirm
          ><span class="picker_confirm">确定</span>
        </template>
        <template #option="item">
          <span class="span_color">{{ item.cat_title }}</span>
        </template>
      </van-picker>
    </van-popup>
    <van-popup class="video_pop" style="width:70%;" round v-model="videoshow">
      <div class="video_title">请完善视频信息</div>
      <label>视频名称</label>
      <div class="inp_box">
        <van-field
          v-model="videoName"
          type="textarea"
          rows="1"
          autosize
          border
          placeholder="请输入视频名称"
        />
      </div>
      <label>视频封面图</label>
      <div class="upImg_box">
        <van-uploader v-model="fileList" :max-count="1" :after-read="afterRead">
        </van-uploader>
      </div>
      <div class="pop_btn">
        <div @click="videoshow = false">取消</div>
        <div @click.stop="postVideo">确认</div>
      </div>
    </van-popup>
    <van-overlay :show="show" class="overlay"
      ><van-loading type="spinner"
    /></van-overlay>
  </div>
</template>

<script>
import { getUploadImageNew, getFollowLstNew } from "@api/public";
import { postArtGet, postVideo } from "@api/lcapi";
import {
  Field,
  Toast,
  Cell,
  Popup,
  Picker,
  Uploader,
  Overlay,
  Loading
} from "vant";
export default {
  name: "AddArticle",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Uploader.name]: Uploader,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading
  },
  data() {
    return {
      value: "", // 链接地址
      pingpai: "", // 品牌
      pingpaiId: "",
      hangyeId: "",
      hangye: "", // 行业
      brand: "",
      cate: "",
      fileList: [],
      brandshow: false,
      cateshow: false,
      videoshow: false,
      videoName: "", // 视频名称
      video_image: "", // 视频封面图
      show: false
    };
  },
  mounted() {
    this.getFollowLstNew();
  },
  methods: {
    /**
     * 获取我的品牌，行业
     */
    getFollowLstNew() {
      getFollowLstNew().then(res => {
        this.brand = res.data.brand;
        this.cate = res.data.cate;
        if (this.brand.length == 0 && this.cate.length == 0) {
          Toast({ message: "请先添加品牌和行业" });
          this.$router.push({ path: "/jiaodian/brand" });
        } else if (this.brand.length == 0 && this.cate.length != 0) {
          Toast({ message: "请先添加品牌" });
          this.$router.push({ path: "/jiaodian/brand" });
        } else if (this.brand.length != 0 && this.cate.length == 0) {
          Toast({ message: "请先添加行业" });
          this.$router.push({ path: "/jiaodian/brand" });
        }
      });
    },
    /**
     * 上传视频
     */
    upvideo() {
      document.getElementById("uploadFile").click();
    },
    readLocalFile() {
      var param = new FormData();
      let files = event.target.files[0];
      param.append("file", files, files.name); //  append 中的 字符串名称 根据后端接口提示修改
      getUploadImageNew(param)
        .then(res => {
          if (res.status == 200) {
            this.value = res.data.url;
            Toast({ message: "上传成功" });
          } else {
            Toast({ message: res.msg });
          }
        })
        .catch(err => {
          Toast({ message: err.msg });
        });
    },
    /**
     * 发布
     */
    issue() {
      if (this.pingpai == "") {
        Toast({ message: "请选择品牌" });
        return;
      }
      if (this.hangye == "") {
        Toast({ message: "请选择行业" });
        return;
      }
      if (this.value == "") {
        Toast({ message: "请添加链接" });
        return;
      }

      let index = this.value.lastIndexOf(".");
      let tv_id = this.value.substring(index);
      if (
        tv_id != ".mp4" &&
        tv_id != ".rmvb" &&
        tv_id != ".avi" &&
        tv_id != ".ts"
      ) {
        // 发布文章
        this.show = true;
        console.log("文章");
        let re = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
        if (re.test(this.value)) {
          console.log("11");
          postArtGet({
            url: this.value,
            bid: this.pingpaiId,
            cid: this.hangyeId
          })
            .then(res => {
              console.log(res);
              if (res.status == 200) {
                Toast({ message: res.msg });
                this.show = false;
                this.$router.push({
                  path: "/jiaodian/imgtextDetail",
                  query: { id: res.data.article_id }
                });
              } else {
                this.show = false;
                Toast({ message: res.msg });
              }
            })
            .catch(err => {
              this.show = false;
              Toast({ message: err.msg });
            });
        } else {
          this.show = false;
          Toast({ message: "上传的链接有误" });
        }
      } else {
        // 发布视频
        console.log("视频");
        this.videoshow = true;
      }
    },
    /**
     * 发布视频
     */
    postVideo() {
      if (this.videoName == "") {
        Toast({ message: "请输入视频名称" });
        return;
      }
      console.log(this.fileList);
      if (this.fileList.length == 0) {
        Toast({ message: "请上传封面图" });
        return;
      }
      this.show = true;
      postVideo({
        video_link: this.value,
        cid: this.hangyeId,
        video_name: this.videoName,
        video_cover: this.video_image
      })
        .then(res => {
          this.show = false;
          if (res.status == 200) {
            Toast({ message: "上传成功，等待审核" });
            this.$router.push({ path: "/" });
          } else {
            Toast({ message: res.msg });
          }
        })
        .catch(err => {
          this.show = false;
          Toast({ message: err.msg });
        });
    },
    /**
     * 品牌选择
     */
    onBrand(e) {
      this.pingpai = e.title;
      this.pingpaiId = e.pid;
      this.brandshow = false;
    },
    /**
     * 行业选择
     */
    onCate(e) {
      console.log(e);
      this.hangye = e.cat_title;
      this.hangyeId = e.pid;
      this.cateshow = false;
    },
    /**
     * 自己写文章
     */
    oneself() {
      Toast({ message: "开发中" });
    },
    /**
     * 上传视频封面图
     */
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      // 此时可以自行将文件上传至服务器
      var param = new FormData();
      param.append("file", file.file, file.file.name);
      getUploadImageNew(param)
        .then(res => {
          if (res.status == 200) {
            console.log(res);
            this.video_image = res.data.url;
            file.status = "done";
            file.message = "上传成功";
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        })
        .catch(err => {
          file.status = "failed";
          file.message = "上传失败";
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.add_article {
  padding-bottom: 1.6rem;
  .pingpai {
    margin: 0.3rem;
    border-radius: 0.1rem;
    overflow: hidden;
  }
  .hangye {
    border-radius: 0.1rem;
    overflow: hidden;
    margin: 0.3rem;
  }
  .add_box {
    margin: 0.3rem 0.3rem 0 0.3rem;
  }
  .add_btn {
    margin: 0.3rem 0.3rem 0 0.3rem;
    text-align: center;
    background: #ff410a;
    color: #ffffff;
    line-height: 0.8rem;
    border-radius: 0.1rem;
    letter-spacing: 0.1rem;
    font-weight: bolder;
    font-size: 0.36rem;
  }
  .add_method {
    padding: 0.6rem 0.3rem 0.3rem 0.3rem;
    h1 {
      text-align: center;
      font-size: 0.46rem;
    }
    h3 {
      margin: 0.3rem 0;
    }
    img {
      width: 100%;
    }
    p {
      color: #999999;
      text-indent: 1em;
    }
  }
  .bottom_btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.2rem 0;
    background: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    div {
      text-align: center;
      flex: 1;
      font-size: 0;
      img {
        width: 0.7rem;
        height: 0.7rem;
      }
      p {
        font-size: 0.24rem;
        font-weight: bold;
        margin-top: 0.1rem;
      }
    }
  }
  .picker_confirm {
    color: #ff410a;
  }
  .video_pop {
    padding-bottom: 0.3rem;
    .video_title {
      text-align: center;
      line-height: 0.8rem;
      font-weight: bold;
      letter-spacing: 0.02rem;
    }
    .inp_box {
      margin: 0 0.3rem;
      border-radius: 0.1rem;
      overflow: hidden;
      border: 0.01rem solid #e9e9e9;
    }
    .upImg_box {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    label {
      padding-left: 0.3rem;
      font-size: 0.26rem;
      margin: 0.2rem 0;
      display: inline-block;
    }
    .pop_btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.3rem;
      margin-top: 0.2rem;
      div {
        width: calc((100% - 0.2rem) / 2);
        text-align: center;
        line-height: 0.6rem;
        font-size: 0.26rem;
        border-radius: 0.06rem;
        border: 0.01rem solid #e9e9e9;
        &:last-child {
          background: #ff410a;
          color: #ffffff;
          border: 0.01rem solid #ff410a;
        }
      }
    }
  }
  .overlay {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
